<!--
 * @Desc:
 * @Author: may.li
 * @Date: 2023-05-11 14:11:36
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2024-01-15 09:44:55
-->
<template>
  <div class="add-danwei">
    <el-form ref="ruleForm"
             :model="viewData"
             :rules="rules"
             label-width="120px">
      <el-form-item label="小区首字母"
                    prop="first_word">
        <el-input size="mini"
                  v-model="viewData.first_word"/>
      </el-form-item>
       <el-form-item label="海康多配置开关"
            prop="use_hk_config">
         <el-switch v-model="viewData.use_hk_config"
              :active-value="1"
              :inactive-value="0"/>
         <span style="margin-left: 10px;color: #999;"></span>
      </el-form-item>
       <el-form-item v-if="viewData.use_hk_config === 0"
            label="海康门禁ip"
            prop="">
         <el-input size="mini"
             v-model="viewData.hk_ip"/>
       </el-form-item>
       <el-form-item v-if="viewData.use_hk_config === 0"
            label="海康所属组织"
            prop="orgIndexCode"
            :required="viewData.park_type === 2">
         <el-input size="mini"
             v-model="viewData.orgIndexCode"/>
       </el-form-item>
       <el-form-item v-if="viewData.use_hk_config === 0"
            label="海康key"
            prop="">
         <el-input size="mini"
             v-model="viewData.hk_key"/>
       </el-form-item>
       <el-form-item v-if="viewData.use_hk_config === 0"
            label="海康secret"
            prop="">
         <el-input size="mini"
             v-model="viewData.hk_secret"/>
       </el-form-item>
       <el-form-item v-if="viewData.use_hk_config === 1"
            label="海康配置">
         <el-button size="mini"
              type="primary"
              @click="openHkConfigDrawer">新增海康配置</el-button>
         <div v-if="viewData.hkConfigArr.length === 0"
           style="margin-top: 8px; color: #999;">暂无海康配置信息</div>
         <div v-else
           style="margin-top: 8px;">
        <div v-for="(item, index) in viewData.hkConfigArr"
          :key="`hk_config_${index}`"
          class="hk-config-item">
          <div>海康门禁IP：{{ item.hk_ip || '-' }}</div>
          <div>海康所属组织：{{ item.orgIndexCode || '-' }}</div>
          <div>海康Key：{{ item.hk_key || '-' }}</div>
          <div>海康Secret：{{ item.hk_secret || '-' }}</div>
          <div>栋号：{{ item.donghao || '-' }}</div>
          <el-button size="mini"
            type="text"
            style="padding: 0;margin-right: 12px;"
            @click="editHkConfig(item, index)">编辑</el-button>
          <el-button size="mini"
               type="text"
               style="padding: 0;"
               @click="removeHkConfig(index)">删除</el-button>
        </div>
         </div>
       </el-form-item>

      <el-form-item label="停车场key"
                    prop="">
        <el-input size="mini"
                  v-model="viewData.park_key"/>
      </el-form-item>
      <el-form-item label="停车场厂商" prop="park_type">
        <el-radio v-model="viewData.park_type" :label="1">捷卫士</el-radio>
        <el-radio v-model="viewData.park_type" :label="2">海康</el-radio>
      </el-form-item>
      <el-form-item label="商户编号"
                    prop="">
        <el-input size="mini"
                  v-model="viewData.cusid"/>
      </el-form-item>
      <el-form-item label="物业电话"
                    prop="">
        <el-input size="mini"
                  v-model="viewData.phone"/>
      </el-form-item>
      <el-form-item label="电子收费章"
                    prop="">
        <image-upload ref="imageUpload"
                      v-if="showUpload"
                      :tipInfo="`上传图片格式为'png'，大小不超过2M，建议尺寸'140*140',请自己处理好宽高比例`"
                      :image-list="imageDefaultList"
                      :maxNumber="1"
                      @updateImg="onUpdateImg($event)"></image-upload>
      </el-form-item>
      <el-form-item label="电子装修协议"
                    prop="">
        <image-upload ref="imageUpload1"
                      v-if="showUpload1"
                      :tipInfo="`上传图片格式为'png'，大小不超过2M，建议尺寸'140*140',请自己处理好宽高比例`"
                      :image-list="imageDefaultList1"
                      :maxNumber="1"
                      @updateImg="onUpdateImg1($event)"></image-upload>
      </el-form-item>
      <el-form-item label="电子装修协议章"
                    prop="">
        <image-upload ref="imageUpload2"
                      v-if="showUpload2"
                      :tipInfo="`上传图片格式为'png'，大小不超过2M，建议尺寸'140*140',请自己处理好宽高比例`"
                      :image-list="imageDefaultList2"
                      :maxNumber="1"
                      @updateImg="onUpdateImg2($event)"></image-upload>
      </el-form-item>
      <el-form-item label="购房赠送积分"
                    prop="fenfa_jifen">
        <el-input-number size="mini"
                         v-model="viewData.fenfa_jifen"
                         :min="0"
                         :precision="0"
                         :step="1"
                         controls-position="right"
                         style="width: 200px"/>
      </el-form-item>
    </el-form>
    <div class="fix-fotter">
      <el-button style="min-width: 117px;background: #1067E0;font-size: 16px;border-color: #1067E0;"
                 size="mini"
                 type="primary"
                 @click="tijiao('ruleForm')">提交
      </el-button>
    </div>

    <el-drawer custom-class="custom-drawer"
               :visible.sync="hkConfigDrawerVisible"
               :close-on-press-escape="false"
               :wrapper-closable="false"
               :show-close="false"
               size="600px"
               append-to-body>
      <template slot="title">
        <div class="custom-title">
          <div class="title-name">新增海康配置</div>
          <i class="el-icon-circle-close close-btn pointer"
             @click="closeHkConfigDrawer"/>
        </div>
      </template>
      <div class="custom-content">
        <el-form :model="hkConfigForm"
                 label-width="120px">
          <el-form-item label="海康门禁IP"
                        required>
            <el-input v-model="hkConfigForm.hk_ip"
                      placeholder="请输入海康门禁IP"/>
          </el-form-item>
          <el-form-item label="海康所属组织"
                        :required="viewData.park_type === 2">
            <el-input v-model="hkConfigForm.orgIndexCode"
                      placeholder="请输入海康所属组织"/>
          </el-form-item>
          <el-form-item label="海康Key"
                        required>
            <el-input v-model="hkConfigForm.hk_key"
                      placeholder="请输入海康Key"/>
          </el-form-item>
          <el-form-item label="海康Secret"
                        required>
            <el-input v-model="hkConfigForm.hk_secret"
                      placeholder="请输入海康Secret"/>
          </el-form-item>
          <el-form-item label="栋号"
                        required>
            <el-input v-model="hkConfigForm.donghao"
                      placeholder="请输入栋号"/>
          </el-form-item>
        </el-form>
        <div class="fix-fotter">
          <el-button size="mini"
                     @click="closeHkConfigDrawer">取消</el-button>
          <el-button style="min-width: 117px;background: #1067E0;font-size: 16px;border-color: #1067E0;"
                     size="mini"
                     type="primary"
                     @click="confirmAddHkConfig">确定</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import ImageUpload from "@/components/Upload/image";
import fetch from "@/api/tianzheng/Qu";
import Pagination from "@/components/Pagination"; // Secondary package based on el-pagination
export default {
  data() {
    return {
      showUpload: false,
      showUpload1: false,
      showUpload2: false,
      thumbList: [],
      thumbList1: [],
      thumbList2: [],
      imageDefaultList: "",
      imageDefaultList1: "",
      imageDefaultList2: "",
      hkConfigDrawerVisible: false,
      hkConfigEditIndex: -1,
      hkConfigForm: {
        hk_ip: "",
        orgIndexCode: "",
        hk_key: "",
        hk_secret: "",
        donghao: ""
      },
      viewData: {
        id: "",
        first_word: "",
        use_hk_config: 0,
        hkConfigArr: [],
        orgIndexCode: '',
        hk_ip: '',
        park_key: '',
        hk_key: '',
        hk_secret: '',
        cusid: '',
        zhang_pic: '',
        phone: '',
        xieyi_pic: '',
        xieyizhang_pic: '',
        fenfa_jifen: 0,
        park_type: 1
      },
      rules: {
        first_word: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur",
          },
        ],
        orgIndexCode: [
          {
            validator: (rule, value, callback) => {
              if (this.viewData.use_hk_config === 0 && this.viewData.park_type === 2 && !value) {
                callback(new Error('请输入海康所属组织'));
              } else {
                callback();
              }
            },
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  components: {
    Pagination,
    ImageUpload
  },
  created() {
  },
  methods: {
    onUpdateImg(val) {
      let thumbList = [];
      val.forEach((ele, idx) => {
        thumbList.push(ele.path);
      });
      this.thumbList = thumbList;
    },
    onUpdateImg1(val) {
      let thumbList = [];
      val.forEach((ele, idx) => {
        thumbList.push(ele.path);
      });
      this.thumbList1 = thumbList;
    },
    onUpdateImg2(val) {
      let thumbList = [];
      val.forEach((ele, idx) => {
        thumbList.push(ele.path);
      });
      this.thumbList2 = thumbList;
    },
    openHkConfigDrawer() {
      this.hkConfigEditIndex = -1
      this.hkConfigForm = {
        hk_ip: "",
        orgIndexCode: "",
        hk_key: "",
        hk_secret: "",
        donghao: ""
      }
      this.hkConfigDrawerVisible = true
    },
    editHkConfig(item, index) {
      this.hkConfigEditIndex = index
      this.hkConfigForm = {
        hk_ip: item.hk_ip || "",
        orgIndexCode: item.orgIndexCode || "",
        hk_key: item.hk_key || "",
        hk_secret: item.hk_secret || "",
        donghao: item.donghao || ""
      }
      this.hkConfigDrawerVisible = true
    },
    closeHkConfigDrawer() {
      this.hkConfigEditIndex = -1
      this.hkConfigDrawerVisible = false
    },
    confirmAddHkConfig() {
      const hk_ip = (this.hkConfigForm.hk_ip || '').trim()
      const orgIndexCode = (this.hkConfigForm.orgIndexCode || '').trim()
      const hk_key = (this.hkConfigForm.hk_key || '').trim()
      const hk_secret = (this.hkConfigForm.hk_secret || '').trim()
      const donghao = (this.hkConfigForm.donghao || '').trim()
      if (!hk_ip || !hk_key || !hk_secret || !donghao) {
        this.$message.warning('请完整填写海康配置信息')
        return
      }
      const configItem = {
        hk_ip,
        orgIndexCode,
        hk_key,
        hk_secret,
        donghao
      }
      if (this.hkConfigEditIndex > -1) {
        this.$set(this.viewData.hkConfigArr, this.hkConfigEditIndex, configItem)
      } else {
        this.viewData.hkConfigArr.push(configItem)
      }
      this.hkConfigEditIndex = -1
      this.hkConfigDrawerVisible = false
    },
    removeHkConfig(index) {
      this.viewData.hkConfigArr.splice(index, 1)
    },
    parseHkConfigArr(value) {
      if (!value) {
        return []
      }
      if (Array.isArray(value)) {
        return value
      }
      if (typeof value === 'string') {
        try {
          const parsed = JSON.parse(value)
          return Array.isArray(parsed) ? parsed : []
        } catch (e) {
          return []
        }
      }
      return []
    },
    /**
     * @name: 初始化列表
     * @param {*} obj
     * @return {*}
     * @desc:
     */
    initFun(obj) {
      this.resetForm()
      let that = this
      this.viewData = {
        id: "",
        first_word: "",
        use_hk_config: 0,
        hkConfigArr: [],
        orgIndexCode: '',
        hk_ip: '',
        park_key: '',
        hk_key: '',
        hk_secret: '',
        cusid: '',
        zhang_pic: '',
        phone: '',
        xieyi_pic: '',
        xieyizhang_pic: '',
        fenfa_jifen: 0,
        park_type: 1
      }
      this.showUpload = true
      this.showUpload1 = true
      this.showUpload2 = true
      if (obj.id) {
        // 编辑
        this.viewData.id = obj.id;
        fetch.detail({id: obj.id}).then((res) => {
          if (res.code == 200) {
            that.viewData = res.result
            that.viewData.id = res.result.id;
            that.viewData.use_hk_config = Number(res.result.use_hk_config || 0)
            that.viewData.park_type = Number(res.result.park_type || 1)
            that.viewData.hkConfigArr = that.parseHkConfigArr(res.result.hkConfigArr)
            if (that.viewData.use_hk_config === 1 && that.viewData.hkConfigArr.length === 0 && (that.viewData.hk_ip || that.viewData.orgIndexCode || that.viewData.hk_key || that.viewData.hk_secret)) {
              that.viewData.hkConfigArr = [{
                hk_ip: that.viewData.hk_ip || '',
                orgIndexCode: that.viewData.orgIndexCode || '',
                hk_key: that.viewData.hk_key || '',
                hk_secret: that.viewData.hk_secret || '',
                donghao: that.viewData.donghao || ''
              }]
            }
            // that.viewData.status == res.result.status === true" ? 1 : 0;
            console.log(that.viewData.status)
            if (that.viewData.zhang_pic && JSON.parse(that.viewData.zhang_pic.length) > 0) {
              let imgList = [];
              let thumb_arr = JSON.parse(that.viewData.zhang_pic);
              thumb_arr.forEach((ele, index) => {
                let obj = {
                  name: ele,
                  path: ele,
                  url: that.$publicData.imgUrl + ele,
                }
                imgList.push(obj);
              })
              // 回显图
              that.imageDefaultList = JSON.stringify(imgList);
            }
            ;
            if (that.viewData.xieyi_pic && JSON.parse(that.viewData.xieyi_pic.length) > 0) {
              let imgList = [];
              let thumb_arr = JSON.parse(that.viewData.xieyi_pic);
              thumb_arr.forEach((ele, index) => {
                let obj = {
                  name: ele,
                  path: ele,
                  url: that.$publicData.imgUrl + ele,
                }
                imgList.push(obj);
              })
              // 回显图
              that.imageDefaultList1 = JSON.stringify(imgList);
            }
            ;
            if (that.viewData.xieyizhang_pic && JSON.parse(that.viewData.xieyizhang_pic.length) > 0) {
              let imgList = [];
              let thumb_arr = JSON.parse(that.viewData.xieyizhang_pic);
              thumb_arr.forEach((ele, index) => {
                let obj = {
                  name: ele,
                  path: ele,
                  url: that.$publicData.imgUrl + ele,
                }
                imgList.push(obj);
              })
              // 回显图
              that.imageDefaultList2 = JSON.stringify(imgList);
            }
            ;
          }
        });
      } else {
        // 新增
      }
    },
    /**
     * @name: 提交
     * @param {*} formName
     * @return {*}
     * @desc:
     */
    tijiao(formName) {
      let that = this
      this.viewData.zhang_pic = this.thumbList;
      this.viewData.xieyi_pic = this.thumbList1;
      this.viewData.xieyizhang_pic = this.thumbList2;
      const submitData = {
        ...this.viewData,
        use_hk_config: Number(this.viewData.use_hk_config || 0),
        hkConfigArr: this.viewData.use_hk_config === 1 ? this.viewData.hkConfigArr : []
      }
      if (submitData.use_hk_config === 1) {
        submitData.hk_ip = ''
        submitData.orgIndexCode = ''
        submitData.hk_key = ''
        submitData.hk_secret = ''
      }
      console.log(this.viewData)
      // if(this.viewData.zhang_pic.length<1){
      //     this.$message.warning("请上传电子收费章")
      //     return
      // }
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.viewData.id) {
            // 编辑
            fetch.edit(submitData).then(res => {
              if (res.code == 200) {
                that.$message.success(res.message);
                that.resetForm()
                that.$emit('onUpdateDrawer', 1)
              } else {
                that.$message.error(res.message);
                that.resetForm()
                that.$emit('onUpdateDrawer', -1)
              }
            })
          } else {
            // 新增
            fetch.create(submitData).then(res => {
              if (res.code == 200) {
                that.$message.success(res.message);
                that.resetForm()
                that.$emit('onUpdateDrawer', 1)
              } else {
                that.$message.error(res.message);
                that.resetForm()
                that.$emit('onUpdateDrawer', -1)
              }
            })
          }

        } else {
          this.$message.warning(this.$t('form.verifyMsg'))
        }
      })
    },
    /**
     * @name: 清空form
     * @return {*}
     * @desc:
     */
    resetForm() {
      this.thumbList = [];
      this.imageDefaultList = "";
      if (this.$refs.imageUpload) {
        this.$refs.imageUpload.clearFileList();
      }
      this.showUpload = false;
      this.thumbList1 = [];
      this.imageDefaultList1 = "";
      if (this.$refs.imageUpload1) {
        this.$refs.imageUpload1.clearFileList();
      }
      this.showUpload1 = false;
      this.thumbList2 = [];
      this.imageDefaultList2 = "";
      if (this.$refs.imageUpload2) {
        this.$refs.imageUpload2.clearFileList();
      }
      this.showUpload2 = false;
      this.$refs["ruleForm"].resetFields();
      this.viewData = {
        id: "",
        first_word: "",
        use_hk_config: 0,
        hkConfigArr: [],
        orgIndexCode: '',
        hk_ip: '',
        park_key: '',
        hk_key: '',
        hk_secret: '',
        cusid: '',
        zhang_pic: '',
        phone: '',
        xieyi_pic: '',
        xieyizhang_pic: '',
        fenfa_jifen: 0,
        park_type: 1
      }
      this.hkConfigForm = {
        hk_ip: "",
        orgIndexCode: "",
        hk_key: "",
        hk_secret: "",
        donghao: ""
      }
      this.hkConfigEditIndex = -1
      this.hkConfigDrawerVisible = false
    },
  },
};
</script>

<style lang="scss" scoped>
.hk-config-item {
  padding: 8px;
  margin-bottom: 8px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background: #fafafa;
}
</style>
